import { logout } from '../../services/auth';
import { login } from '../../constants/internalLinks';

const LogOut = () => {
  logout();
  window.location = login;
};

export default LogOut;
